// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1g-q";
export var animationRelative = "_1g-p";
export var backdropBlur = "_1g-0";
export var detailLabelCell = "_1g-12";
export var detailTable = "_1g-11";
export var detailValueCell = "_1g-13";
export var docIconBox = "_1g-1d";
export var docIconBoxMd = "_1g-1f";
export var docIconBoxSm = "_1g-1e";
export var docTypeRow = "_1g-16";
export var docTypeRowInner = "_1g-17";
export var dropdownMatchDatePicker = "_1g-3";
export var evidenceCardContent = "_1g-1c";
export var fileUploadSpin = "_1g-j";
export var gorgiasOpenButton = "_1g-15 _1g-d";
export var gorgiasTicketCard = "_1g-14";
export var heroModalFooterButton = "_1g-18";
export var hiddenContainer = "_1g-o";
export var iconPrimary = "_1g-1g";
export var iconQuaternary = "_1g-1i";
export var iconTertiary = "_1g-1h";
export var integrationCard = "_1g-1";
export var integrationLogoBox = "_1g-2";
export var mainColumnSticky = "_1g-1b";
export var maxWidthContainer = "_1g-19";
export var modalContentBody = "_1g-a";
export var modalHeaderImage = "_1g-5";
export var modalImageLabel = "_1g-7";
export var modalImageOverlay = "_1g-6";
export var modalImageSubtitle = "_1g-9";
export var modalImageTitle = "_1g-8";
export var modalImageWrapper = "_1g-4";
export var modalStickyFooter = "_1g-b";
export var removeButton = "_1g-e";
export var sidebarColumn = "_1g-1a";
export var spinner = "_1g-i";
export var timelineLine = "_1g-y";
export var timelineLineBlack = "_1g-10 _1g-y";
export var timelineLineGray = "_1g-z _1g-y";
export var timelineLineHeight = "_1g-x";
export var tlDotActivate = "_1g-u";
export var tlDotActivateAnim = "_1g-t";
export var tlDotHide = "_1g-s";
export var tlDotHideAnim = "_1g-r";
export var tlLineActivate = "_1g-w";
export var tlLineActivateAnim = "_1g-v";
export var uploadHint = "_1g-n";
export var uploadIconBox = "_1g-k";
export var uploadLabel = "_1g-m";
export var uploadText = "_1g-l";
export var uploadZone = "_1g-f";
export var uploadZoneCursorDefault = "_1g-h";
export var uploadZoneCursorPointer = "_1g-g";
export var uploadedFileRow = "_1g-c";
export var viewButton = "_1g-d";